import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import MainLayout from './components/layout/mainLayout';
import MainPage from './pages/main';
import PortfolioPage from './pages/project/PortfolioPage';
import ProfilePage from './pages/tim/ProfilePage';
import PageNotFound from './pages/notfound';
import axios from 'axios';
import { Spin } from 'antd';

function App() {

  const [datas, setDatas] = useState([]);
  const [error, setError] = useState("");
  const [loadingPerson, setLoadingPerson] = useState(true);

  function formatNameToPath(name) {
    return name.replace(/\s+/g, '-').toLowerCase();
  }

  const fetchData = async () => {
    try {
      const response = await axios.get("http://devapps.datadrivensystems.co.uk/alcott-profile-api/api/teams/all");
      setDatas(response.data);
    } catch (error) {
      setError(error);
    } 
    finally {
      setLoadingPerson(false);
    }
  }

  useEffect(() => {
    fetchData();
  }, []);

  if (loadingPerson) {
    return (
      <div id="globalLoader">
          <div className="loading-screen">
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
              <div className="dot"></div>
          </div>
      </div>
    );
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <MainLayout>
              <MainPage />
            </MainLayout>
          }
        />
        <Route path="/portfolio" element={<PortfolioPage />} />

        {datas.map((person, index) => (
          <Route
            key={index}
            path={`/${formatNameToPath(person.name)}`}
            element={<ProfilePage person={person} />}
          />
        ))}

        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
